import { bl_sfa_type_hdr_RowClass } from "../../dbschema/bl_sfa_type_hdr.model";
import { BaseContainerModel } from "../base-container.model";

export class SfaTypeHdrContainerModel extends BaseContainerModel {
	bl_sfa_type_hdr: bl_sfa_type_hdr_RowClass = new bl_sfa_type_hdr_RowClass();
}
